// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
export const ownerSettlement = {
  head: {
    title: "Proprietario e liquidazione",
    sub: "Se gestisci questo alloggio per un altro proprietario, stabilisci chi incassa, la tua commissione e come avviene la liquidazione. Da qui si calcolano le sue liquidazioni e le tue analisi del gestore.",
  },
  loading: "Caricamento della configurazione…",
  loadError: {
    title: "Impossibile caricare la configurazione",
    text: "Controlla la connessione e riprova.",
    retry: "Riprova",
  },
  master: {
    label: "Gestisco questo alloggio per un proprietario",
    hintOff: "L'alloggio è tuo: le sue prenotazioni contano come ricavi propri.",
    hintOn: "Le sue prenotazioni vengono liquidate al proprietario con le condizioni qui sotto.",
    kept: "Le condizioni che avevi impostato restano salvate, nel caso lo riattivassi.",
    introTitle: "Una volta attivato:",
    intro1: "Scegli il proprietario e chi incassa le prenotazioni.",
    intro2: "Imposti la tua commissione, la sua IVA e chi tiene le pulizie.",
    intro3: "Vedi subito come risulta la sua liquidazione.",
  },
  owner: {
    title: "Proprietario",
    hint: "La persona o l'azienda a cui liquidi questo alloggio.",
    placeholder: "Scegli un proprietario",
    new: "Nuovo proprietario",
    add: "Aggiungi proprietario",
    edit: "Modifica",
    emptyTitle: "Non hai ancora proprietari",
    emptyText: "Aggiungi il proprietario di questo alloggio per poter fare la liquidazione.",
    missing: "Senza un proprietario assegnato, la liquidazione di questo alloggio non avrà un destinatario.",
    pending: "Assegnato al salvataggio",
    taxId: "C.F./P. IVA",
    addTaxId: "Aggiungi C.F./P. IVA",
    iban: "IBAN",
    addIban: "Aggiungi IBAN",
  },
  ownerForm: {
    titleNew: "Nuovo proprietario",
    titleEdit: "Modifica proprietario",
    sub: "I suoi dati compaiono nelle liquidazioni degli alloggi che gestisci per lui.",
    close: "Chiudi",
    name: "Nome o ragione sociale",
    taxId: "Codice fiscale / P. IVA",
    taxIdHint: "Il suo identificativo fiscale, di qualsiasi paese.",
    taxIdDoubt: "Se è un NIF spagnolo, il carattere di controllo non corrisponde. Se è di un altro paese, ignora questo avviso.",
    email: "Email",
    phone: "Telefono",
    iban: "IBAN",
    ibanPlaceholder: "IT00 X000 0000 0000 0000 0000 000",
    ibanHint: "Il conto su cui gli trasferisci la sua parte.",
    ibanOk: "IBAN valido · {country}",
    address: "Indirizzo",
    notes: "Note",
    notesPlaceholder: "Gli accordi presi, il giorno di pagamento…",
    sharedNote: "È anche il proprietario di {n} altro alloggio: le modifiche si vedranno anche lì. | È anche il proprietario di altri {n} alloggi: le modifiche si vedranno in tutti.",
    cancel: "Annulla",
    save: "Salva proprietario",
    saving: "Salvataggio…",
    created: "Proprietario creato",
    updated: "Proprietario aggiornato",
    deleted: "Proprietario eliminato",
    errName: "Inserisci il nome o la ragione sociale.",
    errEmail: "Controlla l'email: non sembra valida.",
    errIbanFormat: "Un IBAN inizia con il codice del paese e due cifre di controllo (IT60…).",
    errIbanCheck: "Le cifre di controllo non tornano: controlla che sia copiato bene.",
    errIbanLength: "Un IBAN ({country}) ha {expected} caratteri e questo ne ha {actual}.",
    errSave: "Impossibile salvare il proprietario. Riprova.",
    errDelete: "Impossibile eliminare il proprietario. Riprova.",
    delete: "Elimina proprietario",
    deleteTitle: "Eliminare {name}?",
    deleteText: "Sparirà dal tuo elenco di proprietari. Non si può annullare.",
    deleteConfirm: "Elimina",
    deleteBlocked: "Impossibile eliminare: è il proprietario di {n} alloggio. Toglilo prima da lì. | Impossibile eliminare: è il proprietario di {n} alloggi. Toglilo prima da ciascuno.",
    discardTitle: "Scartare le modifiche?",
    discardText: "Quello che hai scritto per questo proprietario andrà perso.",
    discardConfirm: "Scarta",
    discardCancel: "Continua a modificare",
  },
  units: {
    title: "Proprietario di ogni unità",
    hint: "Se un'unità appartiene a un altro proprietario, sceglilo qui. Le altre vengono liquidate al proprietario dell'annuncio.",
    inherit: "Quello dell'annuncio",
    summaryNone: "Tutte del proprietario dell'annuncio",
    summarySome: "{n} unità con un altro proprietario | {n} unità con un altro proprietario",
  },
  collection: {
    title: "Chi incassa le prenotazioni?",
    hint: "Cambia dove vanno i soldi, non quanto resta al proprietario.",
    ownerLabel: "Incassa il proprietario",
    ownerDesc: "Le piattaforme e il tuo sito pagano il proprietario. Poi lui ti paga la fattura dei tuoi compensi (e le pulizie, se sono tue).",
    managerLabel: "Incassa il gestore",
    managerDesc: "I soldi delle prenotazioni arrivano a te. Tieni la tua parte e gli trasferisci la sua.",
    flowBooking: "Prenotazione",
    flowOwner: "Proprietario",
    flowYou: "Tu",
  },
  commission: {
    title: "La tua commissione",
    percent: "Percentuale di commissione",
    vat: "IVA sulla tua commissione",
    base: "Si calcola su",
    presetTotal: "Totale della prenotazione",
    presetAccommodation: "Alloggio senza pulizie",
    presetNet: "Netto dopo la commissione OTA",
    presetDescNet: "{concepts}, senza la loro parte di commissione OTA",
    presetNetClean: "Net of OTA and cleaning",
    presetDescNetClean: "What the owner keeps before your fee: the total minus the OTA, its VAT and cleaning",
    exampleBase: "base nell'esempio",
    custom: "Personalizzato",
    customize: "Regola a mano",
    baseLabel: "Su quale importo",
    gross: "Quello che paga l'ospite",
    net: "Quello che resta dopo la commissione OTA",
    netClean: "What's left after the OTA and cleaning",
    concepts: "Quali voci entrano",
    warnTaxes: "Le tasse non sono ricavi: di solito non ci si applica la commissione.",
    fixTaxes: "Togli le tasse",
    warnCleaning: "Stai applicando la commissione a pulizie che già trattieni.",
    fixCleaning: "Togli le pulizie",
    warnDeposit: "La cauzione si restituisce all'ospite: di solito non ci si applica la commissione.",
    fixDeposit: "Togli la cauzione",
    errPercent: "Inserisci una percentuale tra 0 e 100.",
    errConcepts: "Scegli almeno una voce.",
  },
  concepts: {
    accommodation: "Alloggio",
    cleaning: "Pulizie",
    taxes: "Tasse",
    extras: "Extra",
    deposit: "Cauzione",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»)
  conceptsInline: {
    accommodation: "alloggio",
    cleaning: "pulizie",
    taxes: "tasse",
    extras: "extra",
    deposit: "cauzione",
  },
  cleaning: {
    title: "Pulizie",
    hint: "Chi tiene quello che l'ospite paga per le pulizie?",
    owner: "Sono del proprietario",
    ownerDesc: "Restano nel suo netto: non gli vengono detratte.",
    manager: "Sono tue",
    managerDesc: "Le gestisci tu e vengono detratte al proprietario.",
    charged: "Quello che paga l'ospite per le pulizie",
    fixed: "Un importo fisso per soggiorno",
    fixedAmount: "Importo per soggiorno",
    fixedHint: "Se una prenotazione comprende più camere, si conta una volta per camera.",
    errAmount: "Indica l'importo fisso delle pulizie per soggiorno.",
  },
  ota: {
    title: "Commissione di ogni OTA",
    moved: "La % di ogni OTA si imposta nella scheda «{card}».",
    open: "Apri «{card}»",
  },
  example: {
    title: "Liquidazione di esempio",
    sub: "Una prenotazione di {total} su {channel}, con le tue condizioni attuali.",
    guest: "Quello che paga l'ospite",
    platform: "Quello che trattiene {channel}",
    platformNote: "La sua commissione: {pct}% di {base} ({concepts}).",
    platformYours: "Valgono le tue % di «{card}», anche se {channel} invia la sua commissione.",
    platformReal: "Se {channel} invia la commissione di una prenotazione, si usa quella.",
    platformRule: "Se imposti la % di {channel} in «{card}», vale la tua; altrimenti, la sua commissione.",
    otaVat: "IVA sulla commissione di {channel} ({pct}%)",
    changeIn: "Modifica in «{card}»",
    changeWhere: "Si modifica in «{card}».",
    notOwner: "Quello che non è del proprietario",
    taxes: "Tasse e imposte",
    taxesNote: "Non sono ricavi del proprietario.",
    cleaning: "Pulizie che trattieni",
    cleaningNoteCharged: "Quello che l'ospite paga per le pulizie.",
    cleaningNoteFixed: "Il tuo importo fisso per soggiorno.",
    fees: "I tuoi compensi di gestione",
    commission: "Commissione: {pct}% di {base}",
    commissionBase: "Base: {concepts}.",
    commissionBaseNet: "Base: {concepts}, senza la loro parte di commissione di {channel}.",
    commissionBaseNetClean: "Base: what the owner keeps after {channel}, its VAT and cleaning.",
    vat: "IVA sulla tua commissione ({pct}%)",
    invoice: "Totale della fattura dei tuoi compensi",
    net: "Netto per il proprietario",
    netNote: "Quello che gli spetta per questa prenotazione.",
    netNegative: "Le detrazioni superano quanto lascia la prenotazione.",
    splitTitle: "Come si dividono i {total}",
    legendTaxes: "Tasse",
    legendCleaning: "Pulizie (tue)",
    legendFees: "I tuoi compensi",
    legendOwner: "Proprietario",
    legendDeficit: "Quanto manca",
    transferTitle: "Gli trasferisci {amount}",
    transferTitleTo: "Trasferisci {amount} a {owner}",
    transferInvoice: "E gli emetti la fattura dei tuoi compensi di {amount}.",
    owesTitle: "Il proprietario ti deve {amount}",
    owesTitleFrom: "{owner} ti deve {amount}",
    owesInvoice: "Non c'è niente da trasferire. La fattura dei tuoi compensi è di {amount}.",
    owesHint: "In questo esempio, le detrazioni superano quanto lascia la prenotazione.",
    collectTitle: "Il proprietario ti paga {amount}",
    collectTitleFrom: "{owner} ti paga {amount}",
    collectBreakdown: "È la fattura dei tuoi compensi ({fees}).",
    collectBreakdownCleaning: "La fattura dei tuoi compensi ({fees}) più le pulizie ({cleaning}).",
    ownerLoses: "Con queste condizioni, il proprietario perde {amount} su questa prenotazione.",
    foot: "Importi di esempio. La liquidazione reale usa il dettaglio di ogni prenotazione.",
    footNoOtaVat: "Senza l'IVA sulla commissione dell'OTA.",
  },
  footer: {
    save: "Salva modifiche",
    saving: "Salvataggio…",
    unsaved: "Modifiche non salvate",
    saved: "Salvato",
    fixErrors: "Controlla i campi evidenziati.",
    errSave: "Impossibile salvare. Riprova.",
    peekLabel: "Resta al proprietario",
    peekAria: "Vedi la liquidazione di esempio: al proprietario restano {amount}",
  },
};
